/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Banner_CtaInputs */

const en_homepage_banner_cta = /** @type {(inputs: Homepage_Banner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const es_homepage_banner_cta = /** @type {(inputs: Homepage_Banner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Homepage_Banner_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_banner_cta = /** @type {((inputs?: Homepage_Banner_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Banner_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_banner_cta(inputs)
	return en_homepage_banner_cta(inputs)
});